import React, { Component } from "react";
import ButtonIcon from '../../button';
import CurrentDate from "../date/currentdate.component";
import Icons from "../../icon";
import "./status-data.component.css";
export class StatusData extends Component {
  constructor(props) {
    super(props);
    this.state={
      newDate:new Date(),
      activeIndex: 0
    };
        this.handleOnClick = this.handleOnClick.bind(this);
        this.RefreshData = this.RefreshData.bind(this);
    }

    RefreshData() {
        this.setState({newDate: new Date()});
        this.handleOnClick(0);
    }

  handleOnClick(index) {
      const { activeStatusFilter} = this.props;  
      this.setState({ activeIndex: index });
        activeStatusFilter(index);
  }

  render() {
    const {statusData, showExtractReport} = this.props;   
    return (
      <div className="status-data">
        <div className="header-status-data-container">
          <div className="header-date-container">
            <Icons
                name="arrow-rotate-light"
                size="18px"
                customClassName="icon-date-refresh"
                onClick={this.RefreshData.bind(this)}
            />
            <CurrentDate newdate={this.state.newDate}/>
          </div>
          
          {
            showExtractReport &&
            <div className="statusData-button-container">
                <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="14px" customClassName="extract-button" labelName="Extract Report"/>
            </div>
          }         
        </div>
        <div className="status-data-container">
          {
            statusData.map((data,index)=>{
              const isActive = this.state.activeIndex === index;
              return(
                <div key={index} className={`statusData-wrapper`} onClick={()=>this.handleOnClick(index)}>         
                  <div className={`statusData-container ${isActive ? 'status-active' :""}`}>
                      <div className="statusData-cont">
                      <div className="statusData-inner-container">
                          <div className={`statusData-fill ${data.label.toLowerCase()}`}> </div>
                          <div className="data-wrapper">                 
                          <div className="statusData-value"> 
                          <span className={`value-count ${isActive ? 'value-count-active' : ""}`}>{data.value}</span>
                          <span className="statusData-status">{data.label}</span>
                          </div>
                          </div> 
                      </div>  
                      </div> 
                  </div>
                </div>
              )
            })
          }
        </div>        
        <div className="horizontal-separator"></div>
      </div>
    );
  }
}